import { createFileRoute, Link, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/$")({
  head: () => ({
    meta: [
      { title: "Page not found — Lumvio" },
      { name: "description", content: "This Lumvio page does not exist. Head back to the homepage." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Page not found — Lumvio" },
      { property: "og:description", content: "This Lumvio page does not exist." },
    ],
  }),
  // Throwing notFound() makes SSR answer with a real 404 status instead of 200.
  loader: () => {
    throw notFound();
  },
  notFoundComponent: CatchAllNotFound,
  component: CatchAllNotFound,
});

function CatchAllNotFound() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-6">
      <div className="w-full max-w-md text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">404</p>
        <h1 className="mt-3 text-2xl font-semibold text-foreground">This page doesn&apos;t exist</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The link may be mistyped or the page may have moved. Everything else is working normally.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
          >
            Go to homepage
          </Link>
          <Link
            to="/help"
            className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent"
          >
            Get help
          </Link>
        </div>
      </div>
    </div>
  );
}
